module.exports = __webpack_public_path__ + "static/media/b1_p13_melody.00ec595f.mp3";